import React from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import { ReactComponent as SvgImageFace } from 'assets/svg/Face.svg';
import { ReactComponent as SvgImageVideo } from 'assets/svg/Video.svg';
import { Container, Content, Row, Item, CustomerInformationImagesItem } from './styles';
import moment from 'moment-timezone';

const ReviewCheckIn = ({ scan }) => {

    return (
      <Card>
        <CardHeader>
          <div className='type'>REVIEW CHECK-IN</div>
        </CardHeader>
        <Content>
          <Row>
            <Item>
              <div className='title'>NAME</div>
              <div className='description'>{scan.fullName || "N/A"}</div>
            </Item>
            <Item>
              <div className='title'>DOB (MM/DD/YYYY)</div>
              <div className='description'>{scan.dateOfBirth? moment(scan.dateOfBirth).format('MM/DD/YYYY'): "N/A"}</div>
            </Item>
          </Row>
          {scan?.documentType!=="PASSPORT" && <Row>
            <Item>
              <div className='title'>ADDRESS</div>
              <div className='description'>{scan.address || "N/A"}</div>
            </Item>
          </Row>}
          <Row>
            <Item>
              <div className='title'>TRAVEL DOCUMENT #</div>
              <div className='description'>{scan.documentNumber || "N/A"}</div>
            </Item>
            <Item>
              <div className='title'>TRAVEL DOCUMENT TYPE</div>
              <div className='description'>{scan.documentType || "N/A"}</div>
            </Item>
          </Row>
          <Row>
            <Item>
              <div className='title'>DATE OF ISSUE</div>
              <div className='description'>{scan.dateOfIssue || "N/A"}</div>
            </Item>
            <Item>
              <div className='title'>DOCUMENT EXPIRY</div>
              <div className='description'>{scan.dateOfExpiry? moment(scan.dateOfExpiry).format('MM/DD/YYYY') : "N/A"}</div>
            </Item>
          </Row>
          <Row>
            <Item>
              <div className='title'>PROVINCE/STATE</div>
              <div className='description'>{scan.placeOfBirth || "N/A"}</div>
            </Item>
            <Item>
              <div className='title'>COUNTRY</div>
              <div className='description'>{scan.nationality || "N/A"}</div>
            </Item>
          </Row>
        </Content>
        <Container>
          <div className='title'>VIEW IMAGES:</div>
          <div className='images'>
            <CustomerInformationImagesItem
              onClick={() => { }}
            >
              <SvgImageFace />
              <span>ID Scan</span>
            </CustomerInformationImagesItem>
            <CustomerInformationImagesItem
              onClick={() => { }}
            >
              <SvgImageFace />
              <span>Face</span>
            </CustomerInformationImagesItem>
            <CustomerInformationImagesItem
              onClick={() => { }}
            >
              <SvgImageVideo />
              <span>Video</span>
            </CustomerInformationImagesItem>
          </div>
        </Container>
      </Card>
  )
}

export default ReviewCheckIn;
